/* Points de pagination de la galerie produit sur mobile (audit 2026-09-06, C1 / option 3).
   Le theme monte la galerie avec Splide en forcant `pagination: false`
   (global.bundle.js, productOptions) et la detruit au-dela de 990px. Sans les
   vignettes mobiles (desactivees dans templates/product.json), rien ne
   signalait qu'il y a plusieurs photos : on dessine nos propres points, relies
   a l'instance Splide exposee dans window.slideshows[id]. */
(function () {
  'use strict';

  function buildDots(root, splide) {
    if (root.querySelector('.ez-gallery-dots')) return;
    var count = splide.length;
    if (!count || count < 2) return;

    var nav = document.createElement('div');
    nav.className = 'ez-gallery-dots' + (count > 8 ? ' ez-gallery-dots--many' : '');
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Photos du produit');

    var buttons = [];
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ez-gallery-dots__dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' sur ' + count);
      b.dataset.index = String(i);
      b.addEventListener('click', function (e) {
        splide.go(parseInt(e.currentTarget.dataset.index, 10));
      });
      nav.appendChild(b);
      buttons.push(b);
    }

    function setActive(index) {
      buttons.forEach(function (btn, i) {
        var on = i === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
      });
    }
    /* Audit 2026-11-03-3 (C04) : seul le point actif est tabulable (motif « onglets »),
       les flèches / Début / Fin changent donc de photo et déplacent le focus. */
    nav.addEventListener('keydown', function (e) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      var current = splide.index, target;
      if (e.key in keys) target = (current + keys[e.key] + count) % count;
      else if (e.key === 'Home') target = 0;
      else if (e.key === 'End') target = count - 1;
      else return;
      e.preventDefault();
      splide.go(target);
      setActive(target);
      buttons[target].focus();
    });

    setActive(splide.index);
    splide.on('move', function (newIndex) { setActive(newIndex); });
    splide.on('moved', function (newIndex) { setActive(newIndex); });

    var track = root.querySelector('.splide__track');
    if (track && track.parentNode) track.parentNode.insertBefore(nav, track.nextSibling);
    else root.appendChild(nav);
  }

  function tryInit() {
    var roots = document.querySelectorAll('.splide--product');
    var pending = 0;
    roots.forEach(function (root) {
      if (root.querySelector('.ez-gallery-dots')) return;
      var inst = window.slideshows && root.id ? window.slideshows[root.id] : null;
      if (inst && root.classList.contains('is-initialized')) buildDots(root, inst);
      else pending++;
    });
    return pending === 0;
  }

  /* Splide est monte par un module differe (global.bundle.js) et pose alors la
     classe .is-initialized sur la racine : on observe cette classe plutot que de
     compter sur un delai. Le sondage periodique reste en filet (60 s max) pour
     les navigateurs sans MutationObserver ou si l'instance arrive tard. */
  function watchRoots() {
    document.querySelectorAll('.splide--product').forEach(function (root) {
      if (root._ezDotsObserved || typeof MutationObserver === 'undefined') return;
      root._ezDotsObserved = true;
      var mo = new MutationObserver(function () {
        if (root.classList.contains('is-initialized')) tryInit();
      });
      mo.observe(root, { attributes: true, attributeFilter: ['class'] });
    });
  }

  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    if (tryInit() || attempts > 240) clearInterval(timer);
  }, 250);

  function boot() { watchRoots(); tryInit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', tryInit);
  window.addEventListener('pageshow', tryInit);
  document.addEventListener('shopify:section:load', function () { attempts = 0; watchRoots(); tryInit(); });
})();


/* ---- Partage de la fiche (snippets/product-share.liquid) ---------------------
   navigator.share sur mobile, sinon copie du lien dans le presse-papiers. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ez-share]');
    if (!btn) return;
    e.preventDefault();
    var data = { title: btn.dataset.shareTitle, text: btn.dataset.shareText, url: btn.dataset.shareUrl };
    var toast = btn.parentNode.querySelector('[data-share-toast]');
    function say(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-visible');
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
    }
    if (navigator.share) {
      navigator.share(data).catch(function () { /* annulé par l'utilisateur */ });
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(data.url).then(function () { say('Lien copié'); }, function () { say(data.url); });
    } else {
      window.prompt('Copiez le lien :', data.url);
    }
  });
})();
